"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.AcceptNotificationEvent = void 0;
const Name = exports.Name = 'accept-notification';
const AcceptNotificationEvent = exports.AcceptNotificationEvent = Name;
